/**
 * Custom Google Maps integration with Snazzy Maps
 */

// Snazzy Maps style
const snazzyMapStyle = [
    {
        featureType: 'all',
        elementType: 'geometry',
        stylers: [
            {
                color: '#717171',
            },
        ],
    },
    {
        featureType: 'all',
        elementType: 'labels.text.fill',
        stylers: [
            {
                gamma: 0.01,
            },
            {
                lightness: 20,
            },
        ],
    },
    {
        featureType: 'all',
        elementType: 'labels.text.stroke',
        stylers: [
            {
                saturation: -31,
            },
            {
                lightness: -33,
            },
            {
                weight: 2,
            },
            {
                gamma: 0.8,
            },
        ],
    },
    {
        featureType: 'all',
        elementType: 'labels.icon',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'administrative',
        elementType: 'labels.text.stroke',
        stylers: [
            {
                color: '#ffffff',
            },
        ],
    },
    {
        featureType: 'landscape',
        elementType: 'geometry',
        stylers: [
            {
                lightness: 30,
            },
            {
                saturation: 30,
            },
            {
                color: '#ffffff',
            },
        ],
    },
    {
        featureType: 'landscape',
        elementType: 'labels.text.stroke',
        stylers: [
            {
                color: '#ffffff',
            },
        ],
    },
    {
        featureType: 'landscape.man_made',
        elementType: 'labels.text.stroke',
        stylers: [
            {
                color: '#ffffff',
            },
        ],
    },
    {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [
            {
                saturation: 20,
            },
        ],
    },
    {
        featureType: 'poi',
        elementType: 'geometry.stroke',
        stylers: [
            {
                color: '#ffffff',
            },
        ],
    },
    {
        featureType: 'poi',
        elementType: 'labels.text.stroke',
        stylers: [
            {
                color: '#ffffff',
            },
        ],
    },
    {
        featureType: 'poi.attraction',
        elementType: 'geometry.fill',
        stylers: [
            {
                color: '#000000',
            },
        ],
    },
    {
        featureType: 'poi.business',
        elementType: 'geometry.fill',
        stylers: [
            {
                color: '#000000',
            },
        ],
    },
    {
        featureType: 'poi.government',
        elementType: 'geometry.fill',
        stylers: [
            {
                color: '#000000',
            },
        ],
    },
    {
        featureType: 'poi.medical',
        elementType: 'geometry.fill',
        stylers: [
            {
                color: '#000000',
            },
        ],
    },
    {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [
            {
                lightness: 20,
            },
            {
                saturation: -20,
            },
            {
                color: '#e3e3e3',
            },
        ],
    },
    {
        featureType: 'poi.place_of_worship',
        elementType: 'geometry.fill',
        stylers: [
            {
                color: '#000000',
            },
        ],
    },
    {
        featureType: 'poi.school',
        elementType: 'geometry.fill',
        stylers: [
            {
                color: '#000000',
            },
        ],
    },
    {
        featureType: 'poi.sports_complex',
        elementType: 'geometry.fill',
        stylers: [
            {
                color: '#000000',
            },
        ],
    },
    {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [
            {
                lightness: 10,
            },
            {
                saturation: -30,
            },
        ],
    },
    {
        featureType: 'road',
        elementType: 'geometry.fill',
        stylers: [
            {
                color: '#e8e8e8',
            },
        ],
    },
    {
        featureType: 'road',
        elementType: 'geometry.stroke',
        stylers: [
            {
                saturation: 25,
            },
            {
                lightness: 25,
            },
            {
                color: '#a9a9a9',
            },
        ],
    },
    {
        featureType: 'road',
        elementType: 'labels.text.stroke',
        stylers: [
            {
                color: '#ffffff',
            },
        ],
    },
    {
        featureType: 'transit.station.rail',
        elementType: 'all',
        stylers: [
            {
                visibility: 'simplified',
            },
        ],
    },
    {
        featureType: 'transit.station.rail',
        elementType: 'geometry.stroke',
        stylers: [
            {
                color: '#ff0000',
            },
        ],
    },
    {
        featureType: 'transit.station.rail',
        elementType: 'labels.text.fill',
        stylers: [
            {
                color: '#000000',
            },
        ],
    },
    {
        featureType: 'transit.station.rail',
        elementType: 'labels.text.stroke',
        stylers: [
            {
                color: '#ffffff',
            },
        ],
    },
    {
        featureType: 'water',
        elementType: 'all',
        stylers: [
            {
                lightness: -20,
            },
        ],
    },
    {
        featureType: 'water',
        elementType: 'labels.text',
        stylers: [
            {
                visibility: 'on',
            },
        ],
    },
    {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [
            {
                color: '#000000',
            },
        ],
    },
    {
        featureType: 'water',
        elementType: 'labels.text.stroke',
        stylers: [
            {
                color: '#ffffff',
            },
            {
                visibility: 'on',
            },
        ],
    },
];

// Map pin configuration - centralized for easier future updates
const mapPinConfig = {
    url: '/wp-content/uploads/2025/04/map-pin.svg', // Path to the SVG in media library
    width: 40, // Width of the pin in pixels
    height: 56, // Height of the pin in pixels
    baseColor: '#c62828', // Default color of the pin SVG
    anchorX: 20, // X position of the anchor point (center bottom)
    anchorY: 56, // Y position of the anchor point (bottom of the pin)
};

/**
 * Initialize Google Maps functionality
 */
export function initGoogleMaps() {
    // Only initialize if we're in a browser environment
    if (typeof window === 'undefined') {
        return;
    }

    // Check if maps exist on the page
    const mapElements = document.querySelectorAll('.vt-map');
    if (mapElements.length === 0) {
        return;
    }

    // Wait for vtMapData and Google Maps to be available
    const checkDependencies = () => {
        if (
            typeof window.vtMapData === 'undefined' ||
            typeof window.google === 'undefined' ||
            typeof window.google.maps === 'undefined'
        ) {
            setTimeout(checkDependencies, 500);
            return;
        }

        // Initialize when dependencies are available
        initMaps();
        adjustGmapHeight(); // Call the height adjustment function
    };

    checkDependencies();
}

// Initialize all maps on the page
function initMaps() {
    if (!window.vtMapData || !window.vtMapData.maps) {
        return;
    }

    // Loop through all maps defined in the vtMapData object
    Object.keys(window.vtMapData.maps).forEach((mapId) => {
        const mapData = window.vtMapData.maps[mapId];
        initMap(mapId, mapData);
    });

    // Adjust the height of .gmap after initializing maps
    adjustGmapHeight();
}

// Adjust the height of .gmap to match its child .elementor-shortcode
function adjustGmapHeight() {
    const gmap = document.querySelector('.gmap');
    const shortcode = document.querySelector('.elementor-shortcode');

    if (gmap && shortcode) {
        const updateHeight = () => {
            gmap.style.height = `${shortcode.offsetHeight}px`;
        };

        // Update height on load and resize
        updateHeight();
        window.addEventListener('resize', updateHeight);
    }
}

// Initialize a single map
function initMap(mapId, mapData) {
    const mapElement = document.getElementById(mapId);
    if (!mapElement) {
        return;
    }

    // If latitude and longitude are provided, use them
    if (mapData.latitude && mapData.longitude) {
        const latLng = {
            lat: parseFloat(mapData.latitude),
            lng: parseFloat(mapData.longitude),
        };
        createMap(mapElement, latLng, mapData.zoom, mapData);
    } else {
        // Otherwise, geocode the address
        geocodeAddress(mapData.address, function (latLng) {
            createMap(mapElement, latLng, mapData.zoom, mapData);
        });
    }
}

// Geocode an address to get latitude and longitude
function geocodeAddress(address, callback) {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address: address }, function (results, status) {
        if (status === google.maps.GeocoderStatus.OK && results[0]) {
            const latLng = results[0].geometry.location;
            callback(latLng);
        }
    });
}

// Create the map with marker
function createMap(mapElement, latLng, zoom, mapData) {
    // Simplify our map options and focus on getting the styles to work
    const mapOptions = {
        zoom: parseInt(zoom, 10) || 15, // Changed default zoom from 16 to 14
        center: latLng,
        disableDefaultUI: false, // Enable UI controls
        zoomControl: true, // Specifically enable zoom controls
        mapTypeControl: false, // Disable map type controls
        scaleControl: false, // Disable scale controls
        streetViewControl: false, // Disable Street View
        rotateControl: false, // Disable rotation controls
        fullscreenControl: false, // Disable fullscreen controls
        styles: snazzyMapStyle, // Apply styles directly without Map ID
        draggableCursor: 'default', // Use default cursor instead of hand
        draggingCursor: 'default', // Use default cursor while dragging
        clickableIcons: false, // Disable clickable POIs to maintain consistent behavior
    };

    // Create the map
    const map = new google.maps.Map(mapElement, mapOptions);

    // Get the pin color from the map data
    const pinColor = mapData.pinColor || mapPinConfig.baseColor;

    // Create a marker with the custom SVG
    const pinIcon = {
        url: mapPinConfig.url,
        scaledSize: new google.maps.Size(
            mapPinConfig.width,
            mapPinConfig.height
        ),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(
            mapPinConfig.anchorX,
            mapPinConfig.anchorY
        ),
    };

    // Create the marker with the custom SVG icon
    const marker = new google.maps.Marker({
        position: latLng,
        map: map,
        icon: pinIcon,
        cursor: 'default', // Use default cursor for marker
    });

    // Make the map and marker clickable without changing cursor style
    marker.addListener('click', () => {
        openInGoogleMaps(latLng, mapData.address);
    });

    // Also allow clicking anywhere on the map
    map.addListener('click', () => {
        openInGoogleMaps(latLng, mapData.address);
    });

    // Force the map to update its visual state
    setTimeout(() => {
        google.maps.event.trigger(map, 'resize');
    }, 500);
}

/**
 * Open the location in Google Maps app or website
 *
 * @param {Object} latLng - The latitude and longitude object
 * @param {string} address - The address string
 */
function openInGoogleMaps(latLng, address) {
    // Check if we're on a mobile device
    const isMobile =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
        );

    let mapsUrl;

    if (isMobile) {
        // On mobile, try to use the maps app
        if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
            // Apple Maps uses a different format
            mapsUrl = `maps://?q=${encodeURIComponent(address)}&ll=${
                latLng.lat
            },${latLng.lng}`;
        } else {
            // Google Maps app URL scheme
            mapsUrl = `geo:${latLng.lat},${latLng.lng}?q=${encodeURIComponent(
                address
            )}`;
        }
    } else {
        // On desktop, use Google Maps website
        mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
            address
        )}`;
    }

    // Open in a new tab
    window.open(mapsUrl, '_blank');
}

// Helper function to calculate the hue rotation angle between two colors
// This is a simplistic approach - for more accurate color transformation you'd need more complex conversion
function getHueRotation(fromColor, toColor) {
    // Simple implementation to get a rough hue rotation
    // Convert hex to HSL would be more accurate
    const hueMap = {
        '#c62828': 0, // Default red
        '#ff9900': 45, // Orange
        '#ffeb3b': 90, // Yellow
        '#4caf50': 135, // Green
        '#2196f3': 225, // Blue
        '#9c27b0': 270, // Purple
    };

    // Use the map or estimate a rotation
    if (hueMap[toColor.toLowerCase()]) {
        return hueMap[toColor.toLowerCase()] - hueMap[fromColor.toLowerCase()];
    }

    // Fallback - random rotation based on the color string
    return toColor.split('').reduce((a, b) => a + b.charCodeAt(0), 0) % 360;
}
